
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME } from '../../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'
import { Enums } from '../../../../models/common'
import { PecGliwiceDataTypeGroupCreateEditController } from './pec-gliwice-create-edit.constroller'
import { DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from '../../../../services/data-type-group'

//#region Asset Imports

import './pec-gliwice-create-edit.scss'
import * as TEMPLATE from './pec-gliwice-create-edit.tpl.html'

//#endregion

// Setup

export class PecGliwiceDataTypeGroupCreateEditDirective
    implements ng.IDirective {

    restrict = 'E'

    controller: any = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DATA_TYPE_GROUP_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            userSession: UserSessionService,
            dataTypeGroupService: DataTypeGroupService,
        ) => new PecGliwiceDataTypeGroupCreateEditController(
            $scope,
            $q,
            userSession,
            Enums.ReferenceType.IdDataTypeGroup,
            Enums.SimaxModuleName.Datatype_Group,
            dataTypeGroupService
        )]

    template = TEMPLATE
}